// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"9644c1eb","37":"f76c94c6","114":"5ed75f04","213":"efb44cfc","282":"42edaa99","465":"6724bc7a","649":"ce4076fc","674":"8fb545cc","834":"c27b5f4e","835":"3c835ec1","903":"e8616683","906":"9072cf51","963":"2cccac83","991":"a3e4f706"}[chunkId] + ".chunk.js";
};